import React from 'react';
import { Sparkles, Heart } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';

const Speaking = ({ scrollToSection }) => {
  return (
    <section id="speaking" className="py-24 px-6 bg-gradient-to-br from-teal-100 via-cyan-100 to-blue-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-4">Speaking & Collaboration</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-teal-500 via-purple-500 to-pink-500 mx-auto mb-6"></div>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Available for keynote speeches, workshops, panel discussions, and consulting engagements.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <Card className="p-8 bg-white shadow-lg border-2 border-teal-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Sparkles className="h-6 w-6 text-teal-500 mr-2" />
              Speaking Topics
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="w-2 h-2 bg-gradient-to-r from-teal-500 to-cyan-500 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <span className="text-gray-700"><strong className="text-teal-600">Leadership and Community Impact:</strong> Building sustainable programs that create lasting change</span>
              </li>
              <li className="flex items-start">
                <div className="w-2 h-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <span className="text-gray-700"><strong className="text-purple-600">Entrepreneurship and Business Growth:</strong> Strategic approaches to scaling and sustainability</span>
              </li>
              <li className="flex items-start">
                <div className="w-2 h-2 bg-gradient-to-r from-pink-500 to-red-500 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <span className="text-gray-700"><strong className="text-pink-600">Youth Development and Mentorship:</strong> Empowering the next generation of leaders</span>
              </li>
              <li className="flex items-start">
                <div className="w-2 h-2 bg-gradient-to-r from-orange-500 to-yellow-500 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <span className="text-gray-700"><strong className="text-orange-600">Family and Parenting:</strong> Understanding parent-child dynamics and their long-term impact</span>
              </li>
              <li className="flex items-start">
                <div className="w-2 h-2 bg-gradient-to-r from-rose-500 to-pink-500 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <span className="text-gray-700"><strong className="text-rose-600">Relationships:</strong> Building meaningful connections and fostering healthy relationship dynamics</span>
              </li>
              <li className="flex items-start">
                <div className="w-2 h-2 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <span className="text-gray-700"><strong className="text-indigo-600">Purpose Clarity - Finding You:</strong> Discovering your authentic self and living with intentional purpose</span>
              </li>
            </ul>
          </Card>
          <Card className="p-8 bg-gradient-to-br from-purple-600 to-pink-600 text-white shadow-xl">
            <h3 className="text-2xl font-bold mb-6 flex items-center">
              <Heart className="h-6 w-6 mr-2" />
              Let's Collaborate
            </h3>
            <p className="text-purple-50 mb-6 leading-relaxed">
              Whether you're organizing a conference, corporate event, workshop, or community gathering, I'm passionate about sharing insights that inspire action and drive meaningful results.
            </p>
            <p className="text-purple-50 mb-8">
              I work with organizations of all sizes, from nonprofits to Fortune 500 companies, academic institutions, and community groups.
            </p>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-white text-purple-600 hover:bg-purple-50 px-8 py-6 text-base w-full font-semibold shadow-lg hover:shadow-xl"
            >
              Book Me for Your Event
            </Button>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Speaking;